import axios from "axios";

export const BASE_URL = process.env.NODE_ENV === 'development'? 'http://localhost:4000/api/v1': "https://axaobe.up.railway.app/api/v1"
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials:true,
});

const postApi = async (url, option) => {
  try {
    const res = (await axiosInstance.post(url, option)).data;
    if (res.success) {
      return { data: res, error: null };
    }
    return { data: null, error: res };
  } catch (error) {
    return {
      data: null, 
      error: error.response ? error.response.data : error.message,
    };
  }
};

const fetchApi = async (url) => {
  try {
    const res = (await axiosInstance.get(url)).data;
    if (res.success || res.sucess) {
      return { data: res, error: null };
    }
    return { data: null, error: res };
  } catch (error) {
    return {
      data: null,
      error: error.response ? error.response.data : error.message,
    };
  }
};

export { postApi, fetchApi };
